/**
 * VibeCheck brand logo — uses the official neon devil-heart brand image.
 *
 * The brand mark already includes the "VibeCheck" wordmark baked into the
 * neon-bordered icon, so this component just renders it at the right size
 * for whichever surface needs it (header, splash, modals, etc.).
 *
 *   <Logo size="sm" />     // small inline / tab badge
 *   <Logo size="md" />     // header default
 *   <Logo size="lg" />     // splash / about page
 *
 * The image lives at /assets/brand-icon.png — symlinked from the build asset
 * so it gets cache-busted alongside the rest of the static assets.
 */
import { motion } from "framer-motion";

const SIZES = {
  sm: 30,
  md: 42,
  lg: 72,
  xl: 120,
};

export default function Logo({ size = "md", className = "", animate = true }) {
  const px = SIZES[size] ?? SIZES.md;

  return (
    <motion.span
      className={`inline-flex items-center justify-center select-none ${className}`}
      style={{
        width: px,
        height: px,
        filter:
          "drop-shadow(0 0 12px rgba(255, 46, 154, 0.55)) drop-shadow(0 0 26px rgba(196, 75, 255, 0.4))",
      }}
      animate={animate ? { scale: [1, 1.04, 1] } : undefined}
      transition={animate ? { duration: 3.2, repeat: Infinity, ease: "easeInOut" } : undefined}
      data-testid="vc-logo"
    >
      <img
        src="/assets/brand-icon.png"
        alt="VibeCheck"
        width={px}
        height={px}
        className="block"
        style={{ width: px, height: px, objectFit: "contain" }}
        draggable={false}
      />
    </motion.span>
  );
}
